import { ROLE_COLORS, initials } from "@/lib/orgUtils";
import { Users } from "lucide-react";

export const CoAuthorPicker = ({ allUsers, coAuthors, setCoAuthors, currentUser, view, isNew }) => (
  <div className="p-3 rounded-xl border border-[#181B34]/10" data-testid="coauthors-section">
    <div className="flex items-center gap-2">
      <Users size={15} className="text-[#6161FF]" />
      <span className="text-sm font-bold">Co-authors</span>
      <span className="ml-auto text-[10px] font-bold px-2 py-0.5 rounded-full bg-[#6161FF]/10 text-[#6161FF]">{coAuthors.length}</span>
    </div>
    <p className="text-xs text-[#676a82] font-medium mt-1">Co-authors can edit this chart just like you. Admins can always edit everything.</p>
    {!isNew && view?.created_by_name && (
      <p className="text-xs font-bold text-[#9699AD] mt-2">Created by {view.created_by_name}</p>
    )}
    <div className="mt-2 max-h-40 overflow-auto space-y-1">
      {allUsers.filter((u) => u.id !== (currentUser?.id) && u.id !== view?.created_by && !["super_admin", "admin"].includes(u.role)).map((u) => {
        const on = coAuthors.includes(u.id);
        return (
          <label key={u.id} data-testid={`coauthor-row-${u.email}`} className={`flex items-center gap-2 px-2 py-1.5 rounded-lg cursor-pointer text-sm ${on ? "bg-[#6161FF]/8" : "hover:bg-[#F6F7FB]"}`}>
            <input type="checkbox" checked={on} className="accent-[#6161FF]"
              onChange={() => setCoAuthors(on ? coAuthors.filter((x) => x !== u.id) : [...coAuthors, u.id])} />
            <span className="w-6 h-6 rounded-full bg-[#F0F3FF] text-[#6161FF] flex items-center justify-center text-[9px] font-bold">{initials(u.name || u.email)}</span>
            <span className="font-bold truncate">{u.name || u.email}</span>
            <span className="ml-auto text-[9px] font-bold px-1.5 py-0.5 rounded-full shrink-0" style={{ background: ROLE_COLORS[u.role]?.bg, color: ROLE_COLORS[u.role]?.text }}>{ROLE_COLORS[u.role]?.label}</span>
          </label>
        );
      })}
      {allUsers.filter((u) => !["super_admin", "admin"].includes(u.role) && u.id !== currentUser?.id && u.id !== view?.created_by).length === 0 && (
        <p className="text-xs text-[#9699AD] font-medium p-2">No other editors/viewers to add yet.</p>
      )}
    </div>
  </div>
);
